module.exports = __webpack_public_path__ + "images/Express_Truck.svg";